var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 114,
    fill: "url(#pattern0_14959_22009)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 114,
    fill: "url(#pattern1_14959_22009)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_14959_22009",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_14959_22009",
    transform: "scale(0.00320513)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_14959_22009",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_14959_22009",
    transform: "scale(0.00320513)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_14959_22009",
    width: 312,
    height: 312,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/wAALCAE4ATgBAREA/8QAFgABAQEAAAAAAAAAAAAAAAAAAAoJ/8QAFBABAAAAAAAAAAAAAAAAAAAAAP/aAAgBAQAAPwDVMAAAAAAAAAAAABKuAAqoSrgqoSriqgEq6qgSrqqBKuKqEq6qgEq4ACqgSrqqABKuqoSrqqEq6qgSriqgSrqqEq4CqgEq6qhKuqoSrqqABKuqoEq6qhKuCqhKuqoEq4KqBKuCqgSrgKqEq6qgSrqqBKuqoSrgqoSrqqBKuqoSrgqoSrqqBKuCqhKuKqEq4KqBKuqoEq4qoASrqqEq4KqEq6qgSrqqEq4KqEq6qgSrgqoSriqgSriqgBKuqoASrqqEq6qhKuCqhKuqoEq6qgASrqqAEq6qgEq4qoEq4CqhKuqoBKuqoSrqqABKuqoEq4ACqhKuqoSrqqEq6qhKuqoSrqqEq6qhKuqoSrqqEq6qhKuqoSrqqEq4ACqgAAASrgKqBKuqoEq4qoASrqqEq4KqAAABKuqoASrgqoSriqhKuACqhKuqoSrqqEq6qgBKuqoAEq4qoEq4KqEq4qoSrqqEq4qoSriqhKuAqoSrgKqABKuKqEq4qoAEq4qoBKuKqEq4AqoAASrqqEq6qgEq6qgEq4qoEq4KqASrgqoASrqqASrqqBKuAKqBKuqoASriqhKuqoEq6qhKuKqBKuqoEq6qhKuCqgSrqqAAASrqqBKuKqASrgKqEq6qhKuKqAASriqhKuKqEq6qgSriqhKuqoSrqqEq4CqgEq4KqEq6qgSrqqAEq6qhKuqoBKuqoBKuACqgAEq6qhKuKqEq6qhKuAKqEq4qoASriqgBKuCqhKuqoSriqgSriqhKuCqgEq4qoSriqhKuCqgBKuAAqoSriqgASrqqAEq4ACqhKuKqEq6qhKuCqgSrgqoSrqqAAEq6qhKuqoSrqqAEq6qgEq6qhKuKqBKuqoEq6qgABKuqoEq4KqBKuqoSrqqEq6qgSrgKqBKuqoEq4qoAEq6qhKuqoASrgqoEq4CqgSrgKqASrqqBKuqoEq6qhKuqoASrqqEq6qgBKuKqEq6qhKuAKqEq4qoSrqqAEq6qhKuKqEq4qoBKuACqgABKuKqEq6qhKuKqBKuqoSrqqEq4qoSrgKqEq4CqgSriqhKuqoAAASrqqEq4qoAAEq6qhKuKqASrgCqgBKuCqgSrqqBKuqoSrqqBKuqoSrgCqgSrqqEq6qgSrgKqEq4qoEq6qhKuqoSrqqABKuAKqBKuAKqBKuqoBKuqoEq6qhKuqoAEq4KqEq4qoAABKuqoSrqqEq6qhKuCqgSrqqAEq6qgAEq4AqoAEq6qhKuAqoAEq6qhKuAqoEq4KqASrgqoBKuqoEq4qoBKuqoAAAEq4qoASriqhKuqoAEq6qgSrqqBKuKqAEq4qoSrgqoBKuqoBKuqoSrqqBKuKqBKuAAAKqBKuqoAAASriqgSriqhKuqoSrqqEq4qoEq6qhKuqoEq6qgEq4qoAEq4ACqhKuCqgSrgqoEq4AKqAEq6qhKuqoSrgqoSrqqBKuqoAEq6qgEq6qhKuCqgBKuqoEq4KqEq4KqASriqhKuqoBKuqoSrgqoSrqqBKuqoSrgKqEq6qhKuKqEq6qgEq4AAqoSriqgEq6qhKuCqhKuqoEq6qhKuqoSrqqEq6qgSrqqBKuqoEq6qhKuqoBKuqoBKuqoASrqqEq4KqEq6qgSrqqASrqqEq4qoEq6qgSrqqBKuKqEq6qgSrqqAEq6qgSrqqABKuqoSrqqEq6qgSrqqEq4qoEq4qoBKuqoSrqqEq4CqhKuqoEq6qgSrgAKqBKuqoAASriqhKuqoEq6qgBKuqoSriqgBKuqoAAAAAAAAAAAAAf/Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.f9092d453d39c30288e9b58d7114b36e.svg";
export { ForwardRef as ReactComponent };